import classNames from 'classnames';

import Icon from 'components/Icon/Icon';
import Loader from 'components/Loader';
import SubHeader from 'components/SubHeader';
import type { PropsWithChildren } from 'react';
import { AuthStatus, useClientProfile } from 'store';
import useLayout, { LayoutType } from 'utils/layout';
import { Translation } from 'utils/translations';
import { Redirect } from 'wouter';

import styles from './AccountLayout.module.scss';

type Props = PropsWithChildren & {
  className?: string;
  title: string;
  icon: string;
};

const AccountLayout = ({ className, title, icon, children }: Props) => {
  const layout = useLayout();
  const [{ status }] = useClientProfile();

  if (status === AuthStatus.signedOut) {
    return <Redirect to="/signin" />;
  }

  if (status === AuthStatus.resolving) {
    return <Loader />;
  }

  return (
    <div className={styles['account-layout-wrapper']}>
      <section
        className={classNames(styles['account-layout'], {
          [styles['account-layout-mobile']]: layout === LayoutType.mobile,
        })}
      >
        <SubHeader>
          <div className={styles['account-layout-title']}>
            <Icon name={icon} width={24} height={24} />
            <Translation message={title} />
          </div>
        </SubHeader>
        <div
          className={classNames(
            styles['account-layout-content'],
            {
              [styles['account-layout-content-mobile']]:
                layout === LayoutType.mobile,
            },
            className,
          )}
        >
          {children}
        </div>
      </section>
    </div>
  );
};

export default AccountLayout;
